<template>
    <component :is="component" :data="data" :preview="preview" v-if="component" />
</template>

<script>
export default {
    name: 'dynamic-link',
    props: ['data', 'type', "preview"],
    data() {
        return {
            component: null,
            // type supported: layout, config
        }
    },
    computed: {
        loader() {
            // console.log("dynamic", this.data, this.data.block, this.type)
            if (!this.data.block || !this.type) {
                return null
            } 
            return () => import(`../../blocks/${this.type}/${this.data.block.template}`)
        },
    },
    mounted() {
        this.loader()
            .then(() => {
                console.log("loading...")
                this.component = () => this.loader()
            })
            .catch((error) => {
                console.log("Exception", error);
                this.component = () => import('../../blocks/layout/defaultError')
            })
    },
}
</script>